import { z } from "zod";

import { SUBSCRIPTION_ACTION, SUBSCRIPTION_STATUS } from "@/domains/subscriptions/models/constants";

export const subscriptionLinkResponseSchema = z.object({
  link: z.url(),
});

export const subscriptionStatusSchema = z.enum(SUBSCRIPTION_STATUS);

export const subscriptionActionSchema = z.enum(SUBSCRIPTION_ACTION);
